import { useState } from 'react';

const useSettingsMenu = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isAnimationFinished, setIsAnimationFinished] = useState<boolean>(
        false
    );

    const onClickHandler = () => {
        if (isOpen) {
            setIsOpen(false);
            setIsAnimationFinished(false);
        } else {
            setIsOpen(true);
        }
    };

    return {
        onClickHandler,
        setIsAnimationFinished,
        isOpen,
        isAnimationFinished,
    };
};

export default useSettingsMenu;
